import { AppThunkAction } from ".";
import { UserProfile, SortBAN, BAN } from "./Interfaces";

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).

export const actionCreators = {
  requestuserbans: (
    myCallback: () => void
  ): AppThunkAction<KnownAction> => (dispatch, getState) => {
    // Only load data if it's something we don't already have (and are not already loading)
    const appState = getState();

    if (
      appState &&
      appState.customerbillsstate
    ) {
      if (localStorage.getItem("accessToken") === undefined) {
        window.location.href = "/cabsbillportal/login";
      } else {
        fetch(
          process.env.REACT_APP_API_HOST +
          `/CABSBill/GetBillsByUser`,
          {
            method: "GET",
            // credentials: "include",
            headers: {
              pragma: "no-cache",
              "cache-control": "no-cache",
              'Authorization': 'Bearer ' + localStorage.getItem("accessToken"),
              'Content-Type': 'application/x-www-form-urlencoded'
            },

          }
        )
          .then((response) => {
            if (!response.ok) {

              if (response.status === 401) {
                window.location.href = '/cabsbillportal/login';
              }
              return [];

            } else {


              return response.json() as Promise<BAN[]>;

            }
          })
          .then((data) => {
            dispatch({
              type: "RECEIVE_ALL_USERS",
              payload: { bans: SortBAN(data) },
              isError: false,
            });
            myCallback();
          })
          .catch((error) => {
            dispatch({
              type: "RECEIVE_ALL_USERS",
              payload: { bans: appState.customerbillsstate ? appState.customerbillsstate.bans : [] },
              isError: true,
            });

          });

      }


      dispatch({ type: "REQUEST_ALL_USERS" });
    }
  }, requestsetActiveTab: (
    activeTab: string,
    myCallback: () => void
  ): AppThunkAction<KnownAction> => (dispatch, getState) => {
    // Only load data if it's something we don't already have (and are not already loading)
    const appState = getState();

    if (
      appState &&
      appState.customerbillsstate
    ) {

      dispatch({ type: "REQUEST_SETActiveTab", activeTab: activeTab });
      myCallback();
    }
  }, requestSETDropRight: (
    index: number,
    value: boolean,
    myCallback: () => void
  ): AppThunkAction<KnownAction> => (dispatch, getState) => {
    // Only load data if it's something we don't already have (and are not already loading)
    const appState = getState();

    if (
      appState &&
      appState.customerbillsstate
    ) {

      dispatch({ type: "REQUEST_SETDropRight", index: index, value: value });
      
      myCallback();
    }
  },

};

export const RECEIVE_ALL_USERS = "RECEIVE_ALL_USERS";
export const REQUEST_ALL_USERS = "REQUEST_ALL_USERS";
export const REQUEST_SETMODALSTATE = "REQUEST_SETMODALSTATE";
export const REQUEST_SETActiveTab = "REQUEST_SETActiveTab";
export const REQUEST_SETDropRight = "REQUEST_SETDropRight";

interface RECEIVE_ALL_USERS {
  type: "RECEIVE_ALL_USERS";
  payload: {
    bans: BAN[];
  };
  isError: boolean;
}

interface REQUEST_ALL_USERS {
  type: "REQUEST_ALL_USERS";
}
interface REQUEST_SETMODALSTATE {
  type: "REQUEST_SETMODALSTATE";
  ModalName: string;
  ModalOpen: boolean;
}


interface REQUEST_SETActiveTab {
  type: "REQUEST_SETActiveTab";
  activeTab: string;
}
interface REQUEST_SETDropRight {
  type: "REQUEST_SETDropRight";
  index: number;
  value: boolean;
}

export type KnownAction =
  | RECEIVE_ALL_USERS
  | REQUEST_ALL_USERS
  | REQUEST_SETMODALSTATE
  | REQUEST_SETActiveTab
  | REQUEST_SETDropRight;


